export default __webpack_public_path__ + "static/media/noun_Text Size_3557859.18213d65.png";